module.exports = __webpack_public_path__ + "img/login.9405751c.png";